export default "__VITE_ASSET__Cw12gGey__"